<ts-analysis-type-editor [analysisType]="data.analysisType" [embedInCard]="false" [redirectBack]="false" (submitted)="closeDialog($event)">
</ts-analysis-type-editor>
